import { render, staticRenderFns } from "./expansionPanelList.vue?vue&type=template&id=3c55031e&"
import script from "./expansionPanelList.vue?vue&type=script&lang=js&"
export * from "./expansionPanelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports